import * as React from 'react'
import { compose, pure } from 'recompose'
import * as styles from './RadioButton.css'

interface RadioButtonProps {
  handleChange: (data: any) => void
  selectedOption: string
  value: string
  text?: string
}

const RadioButton: React.FunctionComponent<RadioButtonProps> = ({ handleChange, selectedOption, value, text }) => (
  <div className={styles.radioContainer}>
    <label className={styles.radioButtonLabel}>
      <input
        className={styles.radioInput}
        type="radio"
        value={value}
        checked={selectedOption === value}
        onChange={e => {
          handleChange(Number(e.target.value))
        }}
      />
      {text ? <span className={styles.radioButtonText}>{text}</span> : null}
    </label>
  </div>
)

export default compose<RadioButtonProps, RadioButtonProps>(pure)(RadioButton)
